import { Link } from "react-router"
import { Star } from "lucide-react"

export default function RestCard({restInfo}){

    const info = restInfo?.info;
    const isClosed = info?.availability?.opened === false;

    return (
        <Link to={"/city/delhi/"+info?.id}>
        <div className="bg-cream rounded-2xl overflow-hidden border border-charcoal/10 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-200">
            <div className="relative">
                <img className="w-full h-40 object-cover" alt={info?.name || "Restaurant"} src={"https://media-assets.swiggy.com/swiggy/image/upload/"+info?.cloudinaryImageId}></img>
                {
                    isClosed &&
                    <div className="absolute inset-0 bg-charcoal/70 flex items-center justify-center">
                        <span className="text-cream font-display font-semibold text-lg tracking-wide">Closed</span>
                    </div>
                }
            </div>
            <div className="p-4">
                <div className="font-display font-semibold text-xl text-charcoal truncate">{info?.name}</div>
                <div className="flex items-center gap-2 mt-1.5">
                    <Star className="w-4 h-4 text-curry shrink-0" fill="currentColor" />
                    <span className="text-sm font-mono text-charcoal/80">{info?.avgRating}</span>
                    <span className="text-charcoal/30">•</span>
                    <span className="text-sm font-mono text-charcoal/60">{info?.sla?.slaString}</span>
                </div>
                <div className="text-charcoal/60 text-sm mt-1.5 truncate">{info?.cuisines?.join(", ")}</div>
                <div className="flex items-center justify-between mt-2 text-sm text-charcoal/50">
                    <span>{info?.areaName}</span>
                    {info?.costForTwo && <span className="font-mono">{info.costForTwo}</span>}
                </div>
            </div>
        </div>
        </Link>
    )
}
